import { getCurrentPrelander } from '../../lib/shared/prelander-helpers';
import { resolveStep } from '../../lib/shared/upsell-flow';
import { getSubscriptionId } from './upsell-helpers';

function useUpsellStep(id, conditions = {}) {
    const prelander = getCurrentPrelander();
    const subscriptionId = getSubscriptionId(window.location.search);

    return {
        prelander,
        subscriptionId,
        ...resolveStep({ prelander, id, subscriptionId, conditions })
    };
}

export {
    useUpsellStep
};
